/**
 * Chữ của thẻ "Ảnh bìa và logo" ở Cấu hình → Thông tin tiệm (v0.23.3, docs/plans/thuong-hieu-cua-hang-banner-logo-mau-nganh.md 4.5).
 * Chỉ chủ tiệm thấy, chỉ khi máy chủ báo `anhCuaHang.bat`. Câu ngắn, không thuật ngữ; lỗi hiện NGAY TRONG thẻ / tờ (không đẩy lên thông báo cuối trang).
 */
export const TA = {
  tieuDe: 'Ảnh bìa và logo',
  goiY: 'Khách thấy ảnh ở trang đặt lịch của tiệm. Chưa có ảnh thì dùng màu của ngành.',
  nutThem: 'Thêm ảnh bìa và logo',
  nhacQuyen:
    'Chỉ dùng ảnh hoặc logo của tiệm bạn, hoặc ảnh bạn có quyền dùng. Ảnh có mặt khách phải được khách đồng ý.',
  /** VỪA-3 (soát trải nghiệm 30/10): trên trang đặt lịch của khách thẻ tên cửa hàng + logo che ~1/4 đáy ảnh bìa; ô xem trước ở quầy thì hiện cả ảnh. */
  danBia:
    'Khoảng 1/4 phía dưới ảnh bìa sẽ bị tên cửa hàng che — bạn đặt chữ và hình chính ở nửa trên nhé.',
  nhanBia: 'Ảnh bìa',
  nhanLogo: 'Logo',
  /** Dòng nhỏ dưới tên hàng khi chưa có ảnh. */
  chuaCoBia: 'Đang dùng màu của ngành',
  chuaCoLogo: 'Đang dùng chữ cái đầu của tên tiệm',
  coAnh: 'Đã có ảnh',
  chon: 'Chọn ảnh',
  doi: 'Đổi ảnh',
  go: 'Gỡ',
  /** Nhãn đọc ra cho nút trong từng hàng (nút ngắn, trình đọc màn hình cần biết đang nói về hàng nào). */
  chonBia: 'Chọn ảnh bìa',
  chonLogo: 'Chọn logo',
  doiBia: 'Đổi ảnh bìa',
  doiLogo: 'Đổi logo',
  goBia: 'Gỡ ảnh bìa',
  goLogo: 'Gỡ logo',
  dangChuanBi: 'Đang chuẩn bị ảnh…',
  /** Tờ xem trước đúng ảnh sẽ lưu. */
  tieuDeToBia: 'Ảnh bìa mới',
  tieuDeToLogo: 'Logo mới',
  cauToXemTruoc: 'Khách thấy ảnh này ở trang đặt lịch của tiệm.',
  dung: 'Dùng ảnh này',
  dangLuu: 'Đang lưu ảnh…',
  chonKhac: 'Chọn ảnh khác',
  dongTo: 'Đóng',
  anhXemTruocBia: 'Ảnh bìa sẽ lưu',
  anhXemTruocLogo: 'Logo sẽ lưu',
  /** Hộp xác nhận gỡ (một chạm vào “Gỡ ảnh”). */
  hoiGoBia: 'Gỡ ảnh bìa? Khách sẽ thấy màu của ngành thay cho ảnh.',
  hoiGoLogo: 'Gỡ logo? Khách sẽ thấy chữ cái đầu của tên tiệm.',
  xacNhanGo: 'Gỡ ảnh',
  giuLai: 'Giữ lại',
  dangGo: 'Đang gỡ…',
  daLuuBia: 'Đã lưu ảnh bìa',
  daLuuLogo: 'Đã lưu logo',
  daGoBia: 'Đã gỡ ảnh bìa',
  daGoLogo: 'Đã gỡ logo',
  /** Lỗi — hiện ngay trong thẻ / tờ. */
  loiQuaNangGoc: 'Ảnh quá nặng (tối đa 20 MB). Bạn chọn ảnh nhỏ hơn nhé.',
  loiKhongDoc: 'Máy không mở được ảnh này. Bạn chọn ảnh khác nhé.',
  /** N-GD7: ảnh mở được nhưng máy không nén/vẽ lại được (canvas trả rỗng) — KHÔNG đổ lỗi cho ảnh. */
  loiKhongNen: 'Máy chưa chuẩn bị được ảnh này. Bạn thử chọn lại, hoặc chọn ảnh khác nhé.',
  loiQuaChiTiet: 'Ảnh nhiều chi tiết quá, nén không đủ nhẹ. Bạn chọn ảnh khác nhé.',
  loiQuaNangMayChu: 'Ảnh quá nặng. Bạn chọn ảnh nhỏ hơn nhé.',
  loiMang: 'Mạng đang chậm nên chưa tải xong ảnh. Bạn bấm “Dùng ảnh này” lại nhé.',
  loiMangGo: 'Mạng đang chậm nên chưa gỡ được. Bạn thử lại nhé.',
  loiChuaMo: 'Ảnh cửa hàng chưa mở cho tiệm này.',
  loiQuaNhieu: 'Hôm nay bạn đã đổi ảnh nhiều lần. Ngày mai thử lại nhé.',
  loiChung: 'Chưa lưu được ảnh. Bạn thử lại sau ít phút nhé.',
  loiGoChung: 'Chưa gỡ được ảnh. Bạn thử lại sau ít phút nhé.',
} as const
